import { motion } from "framer-motion";
import { Card } from "../../../components/ui/Card";
import {
  Sparkle,
  GraduationCap,
  Lightning,
  ArrowsClockwise,
} from "@phosphor-icons/react";

const metrics = [
  {
    title: "Code Quality",
    value: "93%",
    description: "Issues caught before they reach production",
    icon: (
      <Sparkle
        size={32}
        weight="thin"
        className="group-hover:animate-subtle-float"
      />
    ),
  },
  {
    title: "Knowledge Sharing",
    value: "2.5x",
    description: "Increase in best practice adoption",
    icon: (
      <GraduationCap
        size={32}
        weight="thin"
        className="group-hover:animate-subtle-float"
      />
    ),
  },
  {
    title: "Review Efficiency",
    value: "30%",
    description: "More thorough reviews in less time",
    icon: (
      <Lightning
        size={32}
        weight="thin"
        className="group-hover:animate-subtle-float"
      />
    ),
  },
  {
    title: "Team Coverage",
    value: "24/7",
    description: "Consistent review standards",
    icon: (
      <ArrowsClockwise
        size={32}
        weight="thin"
        className="group-hover:animate-subtle-float"
      />
    ),
  },
];

export function ROICalculator() {
  return (
    <section id="impact" className="relative py-32">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="aurora-gradient">AI Code Review Impact</h2>
          <p className="mt-4 text-lg text-white/70 max-w-2xl mx-auto">
            Real results from teams using AI-powered code reviews
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {metrics.map((metric, index) => (
            <motion.div
              key={metric.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card variant="hover" className="p-8 h-full group">
                <span className="relative block mb-4">
                  <span className="relative z-10 transform text-white/70 group-hover:text-white transition-colors duration-300">
                    {metric.icon}
                  </span>
                </span>
                <h3 className="text-3xl font-bold bg-gradient-to-r from-white to-white/70 bg-clip-text text-transparent">
                  {metric.value}
                </h3>
                <h4 className="text-lg font-semibold text-white/90 mt-2">
                  {metric.title}
                </h4>
                <p className="mt-2 text-white/70">{metric.description}</p>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
